// React for Website

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
//outsource
import { Row, Col, Segmented, Button, DatePicker } from "antd";

//components
import SearchVoucher from "./component/search_voucher";
import VoucherList from "./component/voucher_list";
import moment from "moment";
import { VOUCHER_STATUS } from "../../store/string";

//redux
import { useDispatch, useSelector } from "react-redux";
import {
  snapRedeemByBranch,
  unSnapRedeem,
} from "../../store/voucher/voucher.action";
import { redeemSelector } from "../../store/voucher/voucher.selector";

import "./style.css";

const { RangePicker } = DatePicker;

const SectionReport = () => {
  // -------------------------- VAR --------------------------
  const params = useParams();
  const packageId = params.packageId || "";
  const branchId = params.id || "";

  // -------------------------- STATE --------------------------
  const [data, setData] = useState(null);
  const [search, setSearch] = useState("");
  const [date, setDate] = useState(null);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const redeem = useSelector(redeemSelector);
  // const vouchers = null;
  const vouchers = redeem
    ?.map((item) => {
      return {
        ...item?.voucher,
        redeemAt: item?.createAt,
        amount: item?.amount,
      };
    })
    ?.filter((row) => row?.voucherPackage === packageId);
  // console.log("redeem", redeem);
  // -------------------------- FUNCTION --------------------------
  const handleChange = (value) => {
    let data = vouchers || [];
    if (value !== "all") {
      data = data?.filter((item) => item?.source === value);
    }
    setData(data);
  };
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (branchId !== "") {
      dispatch(snapRedeemByBranch({ branch: branchId }));
    }

    return () => dispatch(unSnapRedeem());
  }, [branchId]);

  //Load the data
  useEffect(() => {
    if (redeem) {
      const vouchers =
        redeem?.map((item) => {
          return {
            ...item?.voucher,
            redeemAt: item?.createAt,
            amount: item?.amount,
          };
        }) || [];

      const target = vouchers?.filter(
        (item) => item?.voucherPackage === packageId
      );
      setData(target);
    }
  }, [redeem]);

  //filter
  useEffect(() => {
    let data = vouchers || [];
    const from = date ? date[0] : "";
    const to = date ? date[1] : "";

    if (search !== "") {
      data = data?.filter((item) => {
        const lowersearch = search?.toLowerCase();
        const phone = item?.senderPhone?.toLowerCase();
        const code = item?.code?.toLowerCase();
        const valids = code?.includes(lowersearch);
        const validsPhone = phone?.includes(lowersearch);

        return valids || validsPhone;
      });
    }

    //date
    if (from !== "" && to !== "") {
      data = data?.filter((item) => {
        const createAt = item?.createAt && moment(item?.createAt?.toDate());
        const validFrom = createAt >= from;
        const validTo = createAt <= to;
        return validFrom && validTo;
      });
    }

    setData(data);
  }, [date, search]);

  // -------------------------- RENDER --------------------------
  const renderBar = () => {
    return (
      <Row>
        <Col lg={12} md={12} sm={24} xs={24}>
          {renderGiveAway()}
        </Col>
        <Col align="right" lg={12} md={12} sm={24} xs={24}>
          <RangePicker onChange={(date) => setDate(date)} />
        </Col>
      </Row>
    );
  };

  const renderGiveAway = () => {
    return (
      <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
        <SearchVoucher search={search} setSearch={setSearch} />
      </div>
    );
  };

  const renderSegmented = () => {
    const total = SumObject(data);

    return (
      <Row style={{ marginTop: 20 }}>
        <Col lg={12} md={12} sm={24} xs={24}>
          <Segmented
            defaultValue={"all"}
            size="middle"
            options={VOUCHER_STATUS}
            onChange={handleChange}
          />
        </Col>
        <Col align="right" lg={12} md={12} sm={24} xs={24}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              fontWeight: "bold",
            }}
          >
            Total {data?.length || 0} redeemed vouchers |
            <h3 style={{ margin: 0, marginLeft: 20 }}>$ {total}</h3>
          </div>
        </Col>
      </Row>
    );
  };

  const renderList = () => {
    const sort = sortData(data);
    return <VoucherList data={sort} />;
  };

  // -------------------------- MAIN --------------------------
  return (
    <Row className="section-search">
      <Col lg={24} md={24} sm={24} xs={24}>
        {renderBar()}
      </Col>
      <Col lg={24} md={24} sm={24} xs={24}>
        {renderSegmented()}
      </Col>
      <Col lg={24} md={24} sm={24} xs={24}>
        {renderList()}
      </Col>
    </Row>
  );
};

export default SectionReport;

const SumObject = (Array) => {
  const newArray = Array?.map((item) => item?.amount);
  const total = newArray?.reduce((a, b) => a + b, 0) || 0;

  return total;
};

const sortData = (data) => {
  const newSort = data?.sort((a, b) => b?.redeemAt - a?.redeemAt);
  return newSort;
};
